/* eslint-disable max-len */
import { Node, mergeAttributes } from '@tiptap/core';

export interface DocumentEmbedOptions {
  HTMLAttributes?: Record<string, any>;
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    documentEmbed: {
      setDocumentEmbed: (options: {
        url: string;
        documentId: string;
        documentName: string;
        documentType: string;
        documentSize: string;
        themeMode?: string;
      }) => ReturnType;
      removeDocumentEmbed: () => ReturnType;
    };
  }
}

export const DocumentEmbed = Node.create<DocumentEmbedOptions>({
  name: 'documentEmbed',

  group: 'block',
  atom: true,
  selectable: true,
  draggable: false,

  addAttributes() {
    return {
      url: { default: '' },
      documentId: { default: '' },
      documentName: { default: '' },
      documentType: { default: '' },
      documentSize: { default: '' },
      themeMode: { default: 'light' }
    };
  },

  parseHTML() {
    return [
      {
        tag: 'div.document-embed-preview-main-div',
        getAttrs: (dom: HTMLElement) => {
          console.log('Parsing HTML for document embed:', dom);
          return {
            url: dom.getAttribute('url'),
            documentId: dom.getAttribute('documentId'),
            documentName: 'Teamcamp ApiFile Testing',
            documentType: 'Docs',
            documentSize: dom.getAttribute('documentSize'),
            themeMode: dom.getAttribute('themeMode')
          };
        }
      }
    ];
  },

  renderHTML({ HTMLAttributes, node }) {
    console.log('Rendering document embed with attributes:', HTMLAttributes);
    const { documentName, documentType } = HTMLAttributes;

    return [
      'div',
      mergeAttributes(HTMLAttributes, {
        class: 'document-embed-preview-main-div',
        url: HTMLAttributes.url,
        documentId: HTMLAttributes?.documentId,
        documentName: 'Teamcamp ApiFile Testing',
        documentType: 'Docs',
        documentSize: HTMLAttributes?.documentSize,
        themeMode: HTMLAttributes?.themeMode
      }),
      [
        'div',
        { class: 'document-embed-container' },
        [
          'div',
          { class: 'document-embed-icon' },
          [
            'img',
            {
              src: 'https://firebasestorage.googleapis.com/v0/b/teamcamp-app.appspot.com/o/MediaIcons%2Ffile-icon.svg?alt=media&token=93e9dbac-469e-4d76-8af6-18dc4480fc33',
              width: '20',
              height: '28',
              class: 'document-embed-icon-image'
            }
          ]
        ],
        [
          'div',
          { class: 'document-content' },
          ['div', { class: 'file-name' }, documentName || 'Untitled Document'],
          ['div', { class: 'file-type' }, `${documentType.toUpperCase()}`]
        ],
        [
          'div',
          {
            class: 'close-icon',
            'data-command': 'removeDocumentEmbed'
          },
          [
            'img',
            {
              src: 'https://firebasestorage.googleapis.com/v0/b/teamcamp-app.appspot.com/o/MediaIcons%2FIcon-cross.svg?alt=media&token=f208d538-4b7d-4ea1-a577-5c23db75d19c',
              width: '14',
              height: '14',
              class: 'close-icon-image'
            }
          ]
        ]
      ]
    ];
  },

  addCommands() {
    return {
      setDocumentEmbed:
        (options) =>
        ({ commands }) => {
          console.log('Setting document embed with options:', options);
          return commands.insertContent({
            type: this.name,
            attrs: options
          });
        },
      removeDocumentEmbed:
        () =>
        ({ commands, state }) => {
          const { selection } = state;
          const { $from } = selection;
          const node = $from.node();

          if (node.type.name === this.name) {
            return commands.deleteNode(this.name);
          }
          return false;
        }
    };
  }
});

// Helper function to get document icon based on type
// function getDocumentIcon(type: string): string {
//   // Clean up the type to get just the extension
//   const cleanType = type.split('/').pop()?.toLowerCase() || type.toLowerCase();

//   const icons = {
//     pdf: 'https://firebasestorage.googleapis.com/v0/b/teamcamp-app.appspot.com/o/MediaIcons%2Fpdf-icon.svg?alt=media&token=pdf-icon',
//     doc: 'https://firebasestorage.googleapis.com/v0/b/teamcamp-app.appspot.com/o/MediaIcons%2Fdoc-icon.svg?alt=media&token=doc-icon',
//     docx: 'https://firebasestorage.googleapis.com/v0/b/teamcamp-app.appspot.com/o/MediaIcons%2Fdoc-icon.svg?alt=media&token=doc-icon',
//     xls: 'https://firebasestorage.googleapis.com/v0/b/teamcamp-app.appspot.com/o/MediaIcons%2Fxls-icon.svg?alt=media&token=xls-icon',
//     xlsx: 'https://firebasestorage.googleapis.com/v0/b/teamcamp-app.appspot.com/o/MediaIcons%2Fxls-icon.svg?alt=media&token=xls-icon',
//     ppt: 'https://firebasestorage.googleapis.com/v0/b/teamcamp-app.appspot.com/o/MediaIcons%2Fppt-icon.svg?alt=media&token=ppt-icon',
//     pptx: 'https://firebasestorage.googleapis.com/v0/b/teamcamp-app.appspot.com/o/MediaIcons%2Fppt-icon.svg?alt=media&token=ppt-icon',
//     txt: 'https://firebasestorage.googleapis.com/v0/b/teamcamp-app.appspot.com/o/MediaIcons%2Ftxt-icon.svg?alt=media&token=txt-icon',
//     default:
//       'https://firebasestorage.googleapis.com/v0/b/teamcamp-app.appspot.com/o/MediaIcons%2Ffile-icon.svg?alt=media&token=file-icon'
//   };

//   return icons[cleanType as keyof typeof icons] || icons.default;
// }
